import { httpClient } from "Service/Service";
import { RefillEntry, ICashMemoData, ICashMemoResponse } from "./cashMemoSlice";

export const createCashMemoAPI = async (cashMemoData: App.RefillEntry) => {
    try {
        const result = await httpClient("cashmemo", "POST", cashMemoData);
        return result;
    } catch (error: any) {
        console.error("Error creating cash memo:", error);
        throw error;
    }
};

export const getAllCashMemosAPI = async () => {
    try {
        const result = await httpClient("cashmemo", "GET");
        return result;
    } catch (error: any) {
        console.error("Error fetching all cash memos:", error);
        throw error;
    }
};

export const updateCashMemoAPI = async (id: string, cashMemoData: App.RefillEntry) => {
    try {
        const result = await httpClient(`cashmemo/${id}`, "PUT", cashMemoData);
        return result;
    } catch (error: any) {
        console.error(`Error updating cash memo with ID ${id}:`, error);
        throw error;
    }
};